import { usePhases } from "PFCore/hooks/queries/phases/use_phases";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { AvailabilityRule } from "PFTypes/booking/availability";
import { useTranslation } from "react-i18next";

import { AvailabilityChangelog } from "./use_availability_changelog.types";
import { getAvailabilityChangelog } from "./use_availability_changelog.utils";

export const useAvailabilityChangelog = (
  before: AvailabilityRule | null,
  after: AvailabilityRule | null
): AvailabilityChangelog => {
  const { t } = useTranslation(["activities", "translation", "core"]);
  const { formatDate } = useDateFormatter();
  const { data: phasesData } = usePhases();

  return getAvailabilityChangelog(before, after, t, formatDate, phasesData?.entries);
};
